@import '~style-sheet-helpers/core.less';

@font-size: 14px;

.drawer-bulk-package {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 10px;
  font-size: @font-size;

  > .package-input-label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .size-input {
    width: 75px;
  }
}
